<template>
    <div>
        敏感行为监控
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>